import { 

    CLEAR_STATE, 
    SET_ERROR, 
    SET_PAYMENT_DETAILS, 
    SET_SPEND_ALLOWANCE, 
    SET_WALLET_DETAILS, 
    SET_WALLET_STATUS 

} from "./cryptoWalletTypes";

export const setWalletStatus = (status) => {
    return {
        type: SET_WALLET_STATUS,
        payload: status
    }
}

export const setWalletAndChain = (wallet, chainId) => {
    return {
        type: SET_WALLET_DETAILS,
        payload: {wallet, chainId}
    }
}

export const setSpendAllowance = (allowance) => {
    return {
        type: SET_SPEND_ALLOWANCE,
        payload: allowance
    }
}

export const setCryptoPaymentDetails = details => {
    return {
        type: SET_PAYMENT_DETAILS,
        payload: details
    }
}

export const setWalletError = err => {
    return {
        type: SET_ERROR,
        payload: err
    }
}

export const clearState = (opts) => {
    
    return {
        type: CLEAR_STATE,
        payload: opts
    }
}